import { useQuery } from '@tanstack/react-query'
import { practiceApi } from '../api/practice.api'

export const DAILY_LEADERBOARD_QUERY_KEY = ['practice', 'daily', 'leaderboard'] as const

/**
 * Classement du jeu du jour (SPEC §12, `GET /practice/daily/leaderboard`).
 * `enabled` reste à la charge de l'appelant : `DailyCard` ne l'interroge
 * qu'une fois la partie du jour terminée — inutile de le charger avant.
 */
export function useDailyLeaderboard(enabled: boolean) {
  return useQuery({
    queryKey: DAILY_LEADERBOARD_QUERY_KEY,
    queryFn: () => practiceApi.fetchDailyLeaderboard().then((response) => response.data.data),
    enabled,
    staleTime: 30_000,
  })
}
